<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-1/3 sm:m-0 m-4">
      <vx-card>
        <form @submit.prevent="onSubmit" autocomplete="off">
          <div slot="no-body" class="full-page-bg-color">
            <div class="vx-row no-gutter justify-center items-center">
              <div class="vx-col w-full">
                <div class="p-8">
                  <div class="vx-card__title mb-8">
                    <h4 class="mb-4" style="text-align: center;">Nitro Dashboard</h4>
                    <p style="text-align: center;">Hesabınıza ilk girişinizde şifre değişikliği zorunludur.</p>
                  </div>
                  <input style="position: fixed; top: -100px; left: -100px; width: 5px;" type="text" name="fakeusernameremembered" />
                  <input style="position: fixed; top: -100px; left: -100px; width: 5px;" type="password" name="fakepasswordremembered" />
                  <vs-input @keyup="checkPass(this)" autocomplete="chrome-off" type="password" name="password" icon="icon icon-lock" icon-pack="feather" label-placeholder="Yeni Şifre" v-model="password" class="w-full no-icon-border" />
                  <password v-model="password" :secure-length="8" @feedback="showFeedback" @score="showScore" :strength-meter-only="true" />
                  <vs-input
                    @keyup="checkPass(this)"
                    autocomplete="chrome-off"
                    type="password"
                    name="passwordConf"
                    icon="icon icon-lock"
                    icon-pack="feather"
                    label-placeholder="Yeni Şifre Tekrar"
                    v-model="passwordConf"
                    class="w-full mt-6 no-icon-border"
                  />

                  <div v-if="!submitClicked">
                    <vs-button class="float-right mt-5">Onayla</vs-button>
                  </div>
                  <div v-else-if="submitClicked">
                    <p style="text-align: right; margin-top: 16px; font-weight: bolder;">
                      Şifre değişimi başarılı.
                    </p>
                  </div>

                  <vs-divider>www.nitrobilisim.com.tr</vs-divider>
                  <!-- <vs-alert
                    style="height:60px"
                    v-show="ErrorShow"
                    title="Uyarı"
                    color="danger"
                  >{{ errorMessage }}</vs-alert>-->
                </div>
              </div>
            </div>
          </div>
        </form>
      </vx-card>
    </div>
  </div>
</template>

<script>
import { globalFunctions } from "../../_services/globalFunctions";
import { repository } from "../../_services/repository";
import Password from "vue-password-strength-meter";
import { authenticationService } from "../../_services/authentication.service";
import router from "../../router";

// import {
//   router
// } from '@/router';
export default {
  components: { Password },
  data() {
    return {
      ErrorShow: false,
      password: "",
      passwordConf: "",
      score: Number,
      errorMessage: "",
      suggestion: undefined,
      submitClicked: false,
    };
  },
  created() {
    let ctrl = this.$route.params.token.toString().match(/^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i);

    if (!ctrl) {
      document.location = "/";
      return;
    }
  },
  methods: {
    checkPass() {
      if (this.password.length < 8 || this.score < 3) {
        this.ErrorShow = true;
        switch (this.score) {
          case 0:
            this.errorMessage = this.suggestion || "Şifreniz harf, rakam ve karakter içermelidir.";
            break;
          case 1:
            this.errorMessage = this.suggestion || "Şifreniz harf, rakam ve karakter içermelidir.";
            break;
          case 2:
            this.errorMessage = "Daha sonra tekrar deneyiniz.";
            break;
        }
        return;
      }
      if (this.password.length > 0 && this.passwordConf.length > 0 && this.password != this.passwordConf) {
        this.errorMessage = "Şifreleriniz eşleşmiyor!";
        this.ErrorShow = true;
        return;
      }
      this.errorMessage = "";
      this.ErrorShow = false;
    },
    showScore(score) {
      this.score = score;
    },
    showFeedback(a) {
      if (a.suggestions) this.suggestion = a.suggestions[0];
    },

    onSubmit: async function () {
      if (this.errors.any()) {
        return;
      }
      if (this.password == this.passwordConf) {
        this.$vs.loading();

        this.token = this.$route.params.token;
        await authenticationService
          .passwordChange(this.token, this.password)
          .catch((e) => {
            console.warn("şifre değiştirme hatası", e);
            this.ErrorShow = true;
            throw "şifre değiştirme hatası :" + e;
          })

          .then(async () => {

            this.$vs.loading.close();

            await this.$swal.fire({
              icon: "success",
              width: "700px",
              padding: "3em",
              text: "Şifre Değiştirme Başarılı.",
            });

            router.push("../login");
          });
      } else {
        this.$vs.notify({
          color: "danger",
          title: `Hata`,
          text: " Şifreleriniz eşleşmiyor, lütfen kontrol ediniz.",
        });
      }
    },
  },
};
</script>
